import React, { useState } from 'react';
import TeamChat from './TeamChat';
import './ChatPanel.css';

/**
 * Collapsible Chat Panel for Recruiter/Interpreter views
 */
export default function ChatPanel() {
    const [isOpen, setIsOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    return (
        <>
            {/* Chat Toggle Button */}
            <button
                type="button"
                className={`team-chat-panel-toggle ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                aria-label={isOpen ? 'Close Team Chat' : 'Open Team Chat'}
                aria-expanded={isOpen}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <span>Team Chat</span>
                {unreadCount > 0 && (
                    <span className="team-chat-toggle-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                )}
            </button>

            {/* Collapsible Panel */}
            <div className={`team-chat-panel ${isOpen ? 'open' : ''}`}>
                <div className="team-chat-panel-header">
                    <h3>Team Chat</h3>
                    <button
                        type="button"
                        className="team-chat-panel-close"
                        onClick={() => setIsOpen(false)}
                        aria-label="Close chat panel"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
                <div className="team-chat-panel-content">
                    <TeamChat onUnreadCountChange={setUnreadCount} isPanelOpen={isOpen} />
                </div>
            </div>

            {/* Overlay for mobile */}
            {isOpen && (
                <div
                    className="team-chat-panel-overlay"
                    onClick={() => setIsOpen(false)}
                    aria-hidden="true"
                />
            )}
        </>
    );
}
